module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-postcode-9af86b442422f294872b16d5a6e0e53f.png";